module.exports = __webpack_public_path__ + "img/spotmarkt-MOEBEL.gif";